<div class="space-y-8">
<section class="surface-elevated p-6 sm:p-8" style="opacity: 1; transform: none;">
    <h2 class="mb-4 flex items-center gap-2 text-2xl font-semibold text-text-primary">
        <i class="fas" [ngClass]="expert.type === 'developer' || expert.expertType === 'broker_company' ? 'fa-building' : 'fa-users'"></i>
        {{ (expert.type === 'developer' || expert.expertType === 'broker_company' ? 'experts.profile.aboutCompany' : 'experts.profile.aboutMe') | translate }}
    </h2>
    <p class="leading-relaxed text-text-secondary whitespace-pre-line">
        @if (expert.about || expert.aboutCompany) {
            {{ expert.about || expert.aboutCompany }}
        } @else {
            {{ expert.name }} {{ 'experts.profile.defaultAboutPrefix' | translate }} {{ ('experts.types.' + expert.expertType) | translate }} {{ 'experts.profile.defaultAboutMiddle' | translate }} {{ expert.experienceYears }} {{ 'experts.profile.defaultAboutSuffix' | translate }}
        }
    </p>
</section>

<section class="surface-elevated p-6 sm:p-8" style="opacity: 1; transform: none;">
    <h2 class="mb-6 flex items-center gap-2 text-2xl font-semibold text-text-primary">
        <i class="fas fa-briefcase text-xl text-primary"></i>
        {{ (expert.type === 'developer' ? 'experts.profile.specializationsAndFields' : 'experts.profile.servicesProvided') | translate }}
    </h2>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        @if (expert.type === 'developer' && expert.specializations && expert.specializations.length > 0) {
            @for (spec of expert.specializations; track spec) {
                <div class="expert-feature">
                    <i class="fas fa-check-circle"></i>
                    <span>{{ spec }}</span>
                </div>
            }
        } @else if (expert.tags && expert.tags.length > 0) {
            @for (tag of expert.tags; track tag) {
                <div class="expert-feature">
                    <i class="fas fa-tags"></i>
                    <span>{{ tag }}</span>
                </div>
            }
        } @else {
            <div class="expert-feature">
                <i class="fas fa-message"></i>
                <span>{{ 'experts.profile.defaultServices.consultation' | translate }}</span>
            </div>
            <div class="expert-feature">
                <i class="fas fa-chart-line"></i>
                <span>{{ 'experts.profile.defaultServices.valuation' | translate }}</span>
            </div>
            <div class="expert-feature">
                <i class="fas fa-video"></i>
                <span>{{ 'experts.profile.defaultServices.virtualTours' | translate }}</span>
            </div>
            <div class="expert-feature">
                <i class="fas fa-shield-halved"></i>
                <span>{{ 'experts.profile.defaultServices.legalFollowUp' | translate }}</span>
            </div>
        }
    </div>
</section>

@if ((expert.achievementsAndAwards && expert.achievementsAndAwards.length > 0) || (expert.certificatesAndLicenses && expert.certificatesAndLicenses.length > 0) || expert.type !== 'developer') {
<section class="surface-elevated p-6 sm:p-8" style="opacity: 1; transform: none;">
    <h2 class="mb-6 flex items-center gap-2 text-2xl font-semibold text-text-primary">
        <i class="fas fa-award text-xl text-primary"></i>
        {{ 'experts.profile.achievementsAndAwards' | translate }}
    </h2>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        @if (expert.type === 'developer') {
            @for (award of expert.achievementsAndAwards; track award) {
                <div class="achievement-card">
                    <i class="fas fa-trophy"></i>
                    <h3>{{ award }}</h3>
                    <p>{{ 'experts.profile.achievement' | translate }}</p>
                </div>
            }
            @for (cert of expert.certificatesAndLicenses; track cert) {
                <div class="achievement-card">
                    <i class="fas fa-certificate"></i>
                    <h3>{{ cert }}</h3>
                    <p>{{ 'experts.profile.certificateOrLicense' | translate }}</p>
                </div>
            }
        } @else {
            <div class="achievement-card">
                <i class="fas fa-trophy"></i>
                <h3>{{ 'experts.profile.defaultAwards.bestBroker' | translate }}</h3>
                <p>{{ 'experts.profile.defaultAwards.excellenceAward' | translate }}</p>
            </div>
            <div class="achievement-card">
                <i class="fas fa-award"></i>
                <h3>+{{ expert.dealsCount }} {{ 'experts.profile.successfulDealCount' | translate }}</h3>
                <p>{{ 'experts.profile.defaultAwards.successRate' | translate }}</p>
            </div>
            <div class="achievement-card">
                <i class="fas fa-circle-check"></i>
                <h3>{{ 'experts.profile.certifiedBroker' | translate }}</h3>
                <p>{{ 'experts.profile.defaultAwards.officialLicense' | translate }}</p>
            </div>
            <div class="achievement-card">
                <i class="fas fa-star"></i>
                <h3>{{ 'experts.card.rating' | translate }} {{ expert.rating }}/5</h3>
                <p>{{ 'experts.profile.from' | translate }} {{ expert.reviewsCount }} {{ 'experts.profile.client' | translate }}</p>
            </div>
        }
    </div>
</section>
}
</div>
